module.exports = __webpack_public_path__ + "static/media/search.8104a91e.svg";